import { render, staticRenderFns } from "./TypicalPerformance.vue?vue&type=template&id=75395dbc&scoped=true&"
import script from "./TypicalPerformance.vue?vue&type=script&lang=js&"
export * from "./TypicalPerformance.vue?vue&type=script&lang=js&"
import style0 from "./TypicalPerformance.vue?vue&type=style&index=0&id=75395dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75395dbc",
  null
  
)

export default component.exports